import config from '@/services/Config';
import axios from 'axios';
import RequestConfig from '@/services/RequestConfig';

let restModel = 'stats';
let baseUrl = config.apiBaseUrl;

export default {
  getAdminDashboardStats() {
    return axios.get(baseUrl + '/' + restModel + '/admin-dashboard', RequestConfig);
  },

  getRetailerLeadDashboardStats() {
    return axios.get(baseUrl + '/' + restModel + '/retailer-lead-dashboard', RequestConfig);
  },
  
  getRetailerLeadStats(retailerLeadId) {
    return axios.get(baseUrl + '/' + restModel + '/retailer-lead/' + retailerLeadId, RequestConfig);
  },

  getRetailerStats(retailerId) {
    return axios.get(baseUrl + '/' + restModel + '/retailer/' + retailerId, RequestConfig);
  },

  getCharityLeadStats(charityLeadId) {
    return axios.get(baseUrl + '/' + restModel + '/charity-lead/' + charityLeadId, RequestConfig);
  },

  getCharityStats(charityId) {
    return axios.get(baseUrl + '/' + restModel + '/charity/' + charityId, RequestConfig);
  },

  getVolunteerStats(volunteerId) {
    return axios.get(baseUrl + '/' + restModel + '/volunteer/' + volunteerId, RequestConfig);
  }
}
